import React from "react";
import { FormControl, TextField } from "@mui/material";
import Button from "@mui/material/Button";
import {
  LoadedImage,
  LoadedImageBox,
  LoadedImageRemove,
  LoadedImagesContainer,
} from "./styles";
import { AnketaTextImageBlock, IAnketa } from "./model";
import { CameraIcon } from "./CameraIcon";
import { LoadButton, Textarea } from "./controls";

type RepeatableField = "bio" | "honor" | "honorWay";

type Props = {
  title: string;
  field: RepeatableField;
  blocks: AnketaTextImageBlock[];
  nameLabel: string;
  textPlaceholder: string;
  anketa: IAnketa;
  setAnketa: React.Dispatch<React.SetStateAction<IAnketa>>;
};

const RepeatableTextImageSection = ({
  title,
  field,
  blocks,
  nameLabel,
  textPlaceholder,
  anketa,
  setAnketa,
}: Props) => {
  const updateBlocks = (nextBlocks: AnketaTextImageBlock[]) => {
    setAnketa({
      ...anketa,
      [field]: nextBlocks,
    });
  };

  return (
    <>
      <h4>{title}</h4>
      {blocks &&
        blocks.map((block, key) => (
          <FormControl fullWidth sx={{ m: 1 }} key={`${key}-${field}`}>
            <TextField
              value={block.name}
              onChange={(e) =>
                updateBlocks(
                  blocks.map((b, k) => {
                    if (k === key) {
                      return {
                        ...b,
                        name: e.target.value,
                      };
                    }
                    return b;
                  })
                )
              }
              id="outlined-basic2"
              label={nameLabel}
              variant="outlined"
            />
            <Textarea
              aria-label="minimum height"
              placeholder={textPlaceholder}
              minRows={5}
              sx={{ mb: 2 }}
              value={block.text}
              onChange={(e) => {
                updateBlocks(
                  blocks.map((b, k) => {
                    if (k === key) {
                      return {
                        ...b,
                        text: e.target.value,
                      };
                    }
                    return b;
                  })
                );
              }}
            />
            <LoadedImagesContainer>
              <LoadButton variant="contained" component="label" sx={{ mb: 1 }}>
                <CameraIcon />
                Загрузить изображения
                <input
                  type="file"
                  multiple={true}
                  hidden
                  onChange={(e) => {
                    if (!e.target?.files?.length) return;
                    const fileList: File[] = Array.from(e.target.files);
                    const images: { buffer: File; src: string }[] =
                      fileList.map((file) => {
                        return {
                          buffer: file,
                          src: URL.createObjectURL(file),
                        };
                      });
                    updateBlocks(
                      blocks.map((b, k) => {
                        if (k === key) {
                          return {
                            ...b,
                            images: [...(b?.images ?? []), ...images],
                          };
                        }
                        return b;
                      })
                    );
                  }}
                />
              </LoadButton>
              {block.images &&
                block.images.map((img, k) => (
                  <LoadedImageBox key={`${key}-${k}-img`}>
                    <LoadedImage src={img.src} />
                    <LoadedImageRemove
                      onClick={() => {
                        const nextBlocks = [...blocks];
                        nextBlocks[key].images.splice(k, 1);
                        updateBlocks(nextBlocks);
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 384 512"
                      >
                        <path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" />
                      </svg>
                    </LoadedImageRemove>
                  </LoadedImageBox>
                ))}
            </LoadedImagesContainer>
            <Button
              variant="contained"
              component="label"
              onClick={() => {
                const nextBlocks = [...blocks];
                nextBlocks.splice(key, 1);
                updateBlocks(nextBlocks);
              }}
            >
              Убрать
            </Button>
          </FormControl>
        ))}
      <Button
        variant="contained"
        component="label"
        onClick={() => {
          const nextBlocks = [...(blocks ?? [])];
          nextBlocks.push({
            name: "",
            text: "",
            images: [],
          });
          updateBlocks(nextBlocks);
        }}
      >
        Добавить
      </Button>
    </>
  );
};

export default RepeatableTextImageSection;
